export default {
  isLoading({ loadingCount }) {
    if (typeof loadingCount !== 'number' || loadingCount < 0) {
      throw new Error('loadingCount must be a natural number');
    }

    return loadingCount > 0;
  },
};
